import {Component, OnInit, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {RestDataSource} from '../../shared/rest-data-source';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Toast} from '../../shared/toast/toast';
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';
import {TranslateService} from '@ngx-translate/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {PaginatorComponent} from '../../shared/paginator';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import { IdexService } from 'app/idex.service';
import {DeleteFormComponent} from "../../e-form/dialog/delete-form/delete-form.component";
import {AdminApi} from '../admin-api';
import {UploadProgressComponent} from "../../dms/upload-progress/upload-progress.component";
import {UploadService} from "../../dms/upload.service";
import {FileUploader} from "../../dms/file-uploader";
import {Path} from "../../shared/path";
import { PdfTemplateCreateDialogComponent } from '../pdf-template-create-dialog/pdf-template-create-dialog.component';
import { DeletePdfTemplateComponent } from '../delete-pdf-template/delete-pdf-template.component';
import { RenamePdfTemplateDialogComponent } from '../rename-pdf-template-dialog/rename-pdf-template-dialog.component';

@Component({
   selector: 'app-pdf-template-list',
   templateUrl: './pdf-template-list.component.html',
   styleUrls: ['./pdf-template-list.component.scss']
})

export class PdfTemplateListComponent implements OnInit, OnDestroy {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild('wrapper') container: ElementRef;
   @ViewChild(AppLoaderComponent, {static: true}) loader: AppLoaderComponent;
   @ViewChild('search', {static: true}) search: ElementRef;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('progress') progress: UploadProgressComponent;

   private timer: any;
   dataSource = new RestDataSource<any>();
   formType: string;
   selectedRowIndex: number;
   displayedColumns = ['select', 'templateName', 'status', 'createdBy', 'updateDate', 'createdDate', 'versions', 'isActive', 'menu'];
   filterValue = '';
   buttonNew: string;
   orderBy = '';
   orderType = '';
   sortOrder = 'updateDate';
   sortDirect = 'desc';
   searchFocused: boolean;
   index: any;
   size: any;
   searchResult: any[];
   preventBlur: boolean;
   searchvalue: any;
   searching: any;
   draft: any;
   publish: any;
   allData: any[] = [];
   isLoadingResults = false;
   formList = [];
   isSelectAll = false;
   disabledBtn = true;
   data: any;
   hideDeleteButton: boolean = true;

   constructor(private api: AdminApi, private route: ActivatedRoute, private dialog: MatDialog,
               private toast: Toast, private translate: TranslateService, private router: Router,
               private service: IdexService, public uploader: FileUploader) {
   }

   ngOnInit(): void {
      this.translate.get('pdf-template.new-pdf-template').subscribe(s => {
         this.buttonNew = s;
      });
      this.translate.get('eform.status.publish').subscribe(s => {
         this.publish = s;
      });
      this.translate.get('eform.status.draft').subscribe(s => {
         this.draft = s;
      });
      this.clearData();
      this.getBusinessSiteBySiteCode();
   }

   getBusinessSiteBySiteCode() {
      this.service.getBusinessSiteBySiteCode(localStorage.getItem('tin')).subscribe(rs => {
         if (rs) {
            localStorage.setItem('siteCode', rs.siteCode);
            this.getListPdfTemplate('');
         }
      }, e => {
         this.handleErrors(e);
      });
   }

   onClickPdfTemplate(docId: string) {
      localStorage.setItem('url', Path.combine('/admin-tool/pdf-template'));
      this.router.navigate(['/sharefile/' + docId]);
   }

   getListPdfTemplate(type) {
      this.loader.show();
      this.selectedRowIndex = -1;
      this.isLoadingResults = true;
      this.dataSource = new RestDataSource<any>();
      this.dataSource.paginator = this.paginator;
      this.index = this.paginator.page;
      this.size = this.paginator.size;
      localStorage.setItem('page_index', this.index);
      if (this.size === undefined) {
         this.size = 50;
      }
      if (this.sort) {
         this.dataSource.sort = this.sort;
      }

      this.sortOrder = localStorage.getItem('sortOrder') || 'updateDate';
      this.sortDirect = localStorage.getItem('sortDirect') || 'desc';

      if (localStorage.getItem('sortOrder') === 'formName') {
         this.sortOrder = 'updateDate';
      }

      if (type === 'sort' && this.sort) {
         this.sortOrder = this.sort.active;
         this.sortDirect = this.sort.direction;
         localStorage.setItem('sortOrder', this.sortOrder);
         localStorage.setItem('sortDirect', this.sortDirect);
      }
      this.api.listPdfTemplate(localStorage.getItem('siteCode'), this.filterValue, this.sortOrder,
         this.sortDirect, this.index, this.size, null)
         .subscribe(data => {
            this.data = data;
            for (const list of data.content) {
               list.createdDate = new Date(list.createdDate.replace(/-/g, '/')); // new Date(list.createdDate);
               list.updateDate = new Date(list.updateDate.replace(/-/g, '/'));
            }

            this.dataSource.loaded(data);
            this.allData = data.content;
            this.isLoadingResults = false;
            if (this.allData.length === 0) {
               this.isLoadingResults = true;
            }
            this.container.nativeElement.scrollTop = 0;
            this.loader.hide();
         }, e => {
            this.handleErrors(e);
            this.loader.hide();
         });
   }

   // Wait for Specification Error Message
   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

   activeFormList(templateName: string, id: any, event: MatSlideToggleChange) {
      this.api.activePdfTemplate(id, event.checked)
         .subscribe((response) => {
            let index = this.dataSource.data.findIndex((x) => x.templateId === id);
            if (event.checked) {
               this.translate.get('pdf-template.activated', {templateName: templateName}).subscribe(s => {
                  this.toast.success(s);
                  this.hideDeleteButton = true;
                  if (index !== -1) {
                     this.dataSource.data[index].isActive = event.checked;
                     this.selectCheckbox(event, id);
                  }
               });
            } else {
               this.translate.get('pdf-template.inactivated', {templateName: templateName}).subscribe(s => {
                  this.toast.warn(s);
                  this.hideDeleteButton = false;
                  if (index !== -1) {
                     this.dataSource.data[index].isActive = event.checked;
                     this.selectCheckbox(event, id);
                  }
               });
            }
         }, e => {
            this.handleErrors(e);
         });
   }

   clearData() {
      this.paginator.firstPage();
      this.filterValue = '';
      this.search.nativeElement.value = '';
      this.disabledBtn = true;
      this.formList = [];
      this.isSelectAll = false;
   }

   onSearch(value: any) {
      this.searchFocused = false;
      this.searchvalue = value;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = encodeURIComponent(value.trim());
      if (q.length === 0) {
         value = '';
      } else {
         value = value.trim(); // Remove whitespace
         value = value.toLowerCase();
      }
      this.filterValue = q;
      this.getListPdfTemplate('');
   }

   onSearchChange(input: any, e: any) {
      localStorage.setItem('searchValue', input.value);
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      this.filterValue = encodeURIComponent(input.value.trim());
      if (this.filterValue.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.api.listPdfTemplate(localStorage.getItem('siteCode'), this.filterValue, this.orderBy,
            this.orderType, 0, 8, null)
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data.content;
                  }
               });
      }, 300);
   }

   onClickDel(templateId: any) {
      const dialogRef = this.dialog.open(DeletePdfTemplateComponent, {
         disableClose: true,
         height: '110px',
         data: {
            templateId: templateId,
            templateList: this.dataSource.selected,
         },
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result.response) {
            if (result.msg.code === 200) {
               this.toast.success(result.msg.message);
               this.clearData();
               this.getListPdfTemplate('');
            } else {
               this.toast.error(result.msg.message);
            }
         }
      });
   }

   selectCheckbox(event, id) {
      if (id === -1) {
         this.isSelectAll = event.checked;
      }
      const checkFormList = this.checkFormList(this.dataSource.selected);
      if (this.isSelectAll) {
         this.isSelectAll = checkFormList ? true : false;
      }
      this.disabledBtn = this.dataSource.selected.length ? false : true;
   }

   checkFormList(formList) {
      if (formList.length === 0) {
         return false;
      }

      const isPub = formList.some((form) => (form.publishDate && form.isActive) ? true : false);
      if (isPub) {
         return false;
      }
      for (const form of formList) {
         if ((form.publishDate && !form.isActive) || !form.publishDate) {
            return true;
         }
      }
   }

   checkButtonDel(row: any): string {
      return row.publishDate ? 'publish' : 'draft';
   }

   handleMenuButtonClick(row: any, event: MouseEvent) {
      event.stopPropagation();
      if ((row.publishDate === 'draft') || (!this.hideDeleteButton)) {
          event.stopPropagation();
      } else {
          event.preventDefault();
      }
  }

   uploadSelected(files: any): void {
      const file = files[0];
      // const fileBlob = new Blob([file]);
      this.api.uploadPdfTemplate(file, localStorage.getItem('siteCode'))
         .subscribe(data => {
            localStorage.setItem('url', Path.combine('/admin-tool/pdf-template'));
            this.router.navigate(['/sharefile', data.docId]);
            // this.getListPdfTemplate('');
            this.loader.hide();
         }, e => {
            this.handleErrors(e);
            this.loader.hide();
         });
   }

   newBlank() {
      const pdfTemplate = this.dialog.open(PdfTemplateCreateDialogComponent, {
         disableClose: true,
         data: this,
      })
      pdfTemplate.afterClosed().subscribe(result => {
         this.loader.show();
         if (result) {
            localStorage.setItem('url', Path.combine('/admin-tool/pdf-template'));
            this.router.navigate(['/sharefile', result.docId]);
            this.loader.hide();
         } else {
            this.loader.hide();
         }
      });
   }

   beginRename(row: any) {
      const dialogRef = this.dialog.open(RenamePdfTemplateDialogComponent, {
         disableClose: true,
         data: {
            templateInfo: row
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         if (result && result.response) {
            this.toast.success('Template renamed successfully');
            setTimeout(() => {
               this.getListPdfTemplate('');
            }, 500);
         } else if (result && result.error) {
            this.toast.error('Error renaming template: ' + result.error);
         }
      });
   }

   ngOnDestroy(): void {
      if (localStorage.getItem('sortOrder') === 'templateName') {
         localStorage.setItem('sortOrder', 'updateDate');
      }
   }
}

